<h2>Portal Users</h2>



<div class="grid col-9">
        <div class="col-2">
            <label for="selectedUserName" class="margin-left">Username: </label>
            <input pInputText id="selectedUserName" [(ngModel)]="selectedUserName" placeholder="Username:"/> 
        </div>  
        @if (isAciStaff) {
          <div class="col-2">
              <!-- "isPortalAdmin || isAciStaff" -->
              <label for="selectedRoleName" class="margin-left">Role Name: </label>
              <p-select id ="selectedRoleName" [options]="roleNames" [(ngModel)]="selectedRoleName" [filter]="false" 
                  placeholder="Role Name:" [editable]="false"  [style]="{'width': '90%'}" ></p-select>
          </div>  
          <div class="col-2">
              <!-- ngIf="isPortalAdmin || isAciStaff" -->
              <label for="selectedUserType" class="margin-left">User Type: </label>
              <p-select id ="selectedUserType" [options]="userTypes" [(ngModel)]="selectedUserType" [filter]="false" 
                  placeholder="User Type:" [editable]="false" [style]="{'width': '90%'}" ></p-select>
          </div>  
          <div class="col-2">
              <label for="selectedBrandCodes" class="margin-left">Brand: </label>
              <p-select id ="selectedBrandCode" [options]="brandCodesForCriteria" [(ngModel)]="selectedBrandCode" [filter]="false" 
                  placeholder="Brand:" [editable]="false" [style]="{'width': '90%'}" ></p-select>
          </div>  
        }
        <div class="col-1">
            <p-button label="Search" styleClass="p-button-success wal-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($event)"></p-button>
        </div>  
        <div class="col-1">
            <p-button label="Clear" styleClass="p-button-danger wal-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="onClearClick($event)"></p-button>
        </div>  

    <div class="col-2" id="idSpinner" [hidden]="isSpinnerHidden">
        <div class="loader">
    </div>  
</div>

<div class="grid col-10">

        <p-table #dt [columns]="cols" [value]="users" selectionMode="single" [(selection)]="selectedUser" 
            class="wal-table"
            sortMode="multiple" (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="15" [rowsPerPageOptions]="[15,25,50,75]">
          <ng-template #caption>
              List of Users
          </ng-template>
          <ng-template #header let-columns>
              <tr>
                @for (col of columns; track col.field) {
                  <th [pSortableColumn]="col.field"
                    [style.display]="col.display"
                    [style.width]="col.width">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                }
              <th pSortableColumn="enabled" style="width: 5%">Enabled? <p-sortIcon field="enabled"></p-sortIcon></th>
              <th pSortableColumn="locked" style="width: 5%">Locked? <p-sortIcon field="locked"></p-sortIcon></th>
            </tr>
              <tr>

                <!-- <th *ngFor="let col of columns" [ngSwitch]="col.field" [ngStyle]="{'width': col.width, 'display': col.display}">
                    <input pInputText type="text" (input)="dt.filter($any($event.target).value, col.field, col.filterMatchMode)" />
                </th> -->

                @for (col of columns; track col.field) {
                  <th [style.width]="col.width" [style.display]="col.display">
                    <input pInputText
                          type="text"
                          (input)="dt.filter($any($event.target).value, col.field, col.filterMatchMode)" />
                  </th>
                }

            </tr>  
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                  <td>
                    <p-tag [value]="rowData.enabled ? 'Y' : 'N'" [severity]="getEnabled(rowData.enabled)"></p-tag>
                  </td>                  
                  <td>
                    <p-tag [value]="rowData.locked ? 'Y' : 'N'" [severity]="getLocked(rowData.locked)"></p-tag>
                  </td>                  
    
                </tr>
          </ng-template>
          <ng-template pTemplate="summary" let-rowData>
              <div style="text-align:left" *ngIf="isSubmitShown">
                <p-button label="Add" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="showDialogToAdd()"></p-button>
              </div>
          </ng-template>    
          </p-table> 
      
</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body"></p-confirmDialog>

<p-dialog appendTo="body" header="User Details" [(visible)]="displayDialog" [focusOnShow]="false" [responsive]="true" 
    styleClass="wal-dialog"
        showEffect="fade" [modal]="true"   [style]="{ width: '70em' }">
    <div *ngIf="user">

        <p-tabs class="wal-tabs" [(value)]="tabIndex" (valueChange)="onActiveTabChange($event)">

          <p-tablist>

            <p-tab [value]="'properties'">
              <span class="tab-label">
                <i class="pi pi-user-edit" aria-hidden="true"></i>
                <span class="ml-2">Properties</span>
              </span>
            </p-tab>

            @if(isRoleTabpageShown) {
            <p-tab [value]="'roles'">
              <span class="tab-label">
                <i class="pi pi-check-circle" aria-hidden="true"></i>
                <span class="ml-2">Roles</span>
              </span>
            </p-tab>
            }

            @if(!allBrandsGrant) {
            <p-tab [value]="'brands'">
              <span class="tab-label">
                <i class="pi pi-sitemap" aria-hidden="true"></i>
                <span class="ml-2">Brands</span>
              </span>
            </p-tab>
            }

            @if(!newUser) {
            <p-tab [value]="'passwordReset'">
              <span class="tab-label">
                <i class="pi pi-sync" aria-hidden="true"></i>
                <span class="ml-2">Password Reset</span>
              </span>
            </p-tab>
            }

          </p-tablist>  

          <p-tabpanels>

            <p-tabpanel [value]="'properties'">

              <p-card header="User Attributes" subheader="" styleClass="ui-card-light">

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="userId" class="col-fixed label" style="width: 12em">User Id:</label>
                      <div class="col">
                        <input pInputText id="userId" [(ngModel)]="user.userId" autofocus [disabled]="true"/>
                      </div>
                    </div>
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="userName" class="col-fixed label" style="width:12em">Username:</label>
                      <div class="col">
                          <input pInputText id="userName" [(ngModel)]="user.userName" style="width: 15em">
                      </div>
                    </div>
                </div>    

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="password" class="col-fixed label" style="width: 12em">Password:</label>
                      <div class="col">
                        <input pPassword type="password" id="password" [(ngModel)]="user.password" [disabled]="!newUser"/>
                      </div>
                    </div>
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="userType" class="col-fixed label" style="width:12em">User Type:</label>
                      <div class="col">
                        <p-select id ="userType" [options]="userTypes" [(ngModel)]="userType"  
                            (onChange)="onChangeUserType($event)"
                            [filter]="false" [editable]="false"> 
                        </p-select>
                      </div>
                    </div>
                </div>    

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="emailAddress" class="col-fixed label" style="width: 12em">Email Address:</label>
                      <div class="col">
                        <input pInputText type="email" id="emailAddress" [(ngModel)]="user.emailAddress" style="width: 20em"
                        validatorMessage="Value does not match pattern." pTooltip="Examle: jane.doe@gmail.com" tooltipPosition="top" 
                              pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"/>                    
                      </div>
                    </div>
                </div>                 

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="passwordChangeRequired" class="col-fixed label" style="width: 12em">Password Reset:</label>
                      <div class="col">
                        <p-checkbox [(ngModel)]="user.passwordChangeRequired" id="passwordChangeRequired" [binary]="true"></p-checkbox>
                      </div>
                    </div>
                    <div class="col-3"></div>
                    <div class="field grid" *ngIf="hasAllBrandsAttribute">
                      <label for="allBrandsGrant" class="col-fixed label" style="width:12em">All Brands Grant:</label>
                      <div class="col">
                        <p-checkbox [(ngModel)]="allBrandsGrant" id="allBrandsGrant" [binary]="true"></p-checkbox>
                      </div>
                    </div>
                </div>    

                <div class="grid">
                  <div class="col-1"></div>
                  <div class="field grid">
                    <label for="enabled" class="col-fixed label" style="width: 12em">Enabled:</label>
                    <div class="col">
                      <p-checkbox [(ngModel)]="user.enabled" id="enabled" [binary]="true"></p-checkbox>
                    </div>
                  </div>
                  <div class="col-3"></div>
                  <div class="field grid">
                    <label for="locked" class="col-fixed label" style="width:12em">Locked:</label>
                    <div class="col">
                      <p-checkbox [(ngModel)]="user.locked" id="locked" [binary]="true"></p-checkbox>
                    </div>
                  </div>
              </div>    

              <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="loginFailCount" class="col-fixed label" style="width: 12em">Login Fail Cnt:</label>
                      <div class="col">
                        <input pInputText id="loginFailCount" [(ngModel)]="user.loginFailCount" [disabled]="true"/>
                      </div>
                    </div>
                    <div class="col-1"></div>
                    <div class="field grid" *ngIf="hasAllBrandsAttribute">
                      <label for="lastLogin" class="col-fixed label" style="width:12em">Last Login:</label>
                      <div class="col">
                        <input pInputText id="lastLogin" [(ngModel)]="user.lastLogin" [disabled]="true"/>
                      </div>
                    </div>
                </div>    

                <div class="grid">
                    <div class="col-1"></div>
                    <div class="field grid">
                      <label for="createDate" class="col-fixed label" style="width: 12em">Create Date:</label>
                      <div class="col">
                        <input pInputText id="createDate" [(ngModel)]="user.createDate" [disabled]="true"/>
                      </div>
                    </div>
                    <div class="col-1"></div>
                    <div class="field grid" *ngIf="hasAllBrandsAttribute">
                      <label for="lastUpdateDate" class="col-fixed label" style="width:12em">Update Date:</label>
                      <div class="col">
                        <input pInputText id="lastUpdateDate" [(ngModel)]="user.lastUpdateDate" [disabled]="true"/>
                      </div>
                    </div>
                </div>    

                <p-footer>
                  <mat-icon class="nav-caption wal-center">add_a_photo</mat-icon>
                </p-footer>
  
              </p-card>                

            </p-tabpanel>

            <p-tabpanel [value]="'roles'">

                <p-pickList [source]="availableRoles" [target]="grantedRoles"  class="wal-picklist"
                        sourceHeader="Available" targetHeader="Granted" 
                        [sourceStyle]="{height:'25rem'}" [targetStyle]="{height:'25rem'}"  
                        filterBy="label" filter = "true"
                        [targetOptionDisabled]="isRoleLocked"
                        (onSourceSelect)=onRoleSelect($event) (onTargetSelect)="onRoleSelect($event)"
                        (onMoveToSource)="onMoveToSource($event)" (onMoveAllToSource)="onMoveAllToSource($event)"
                        (onMoveToTarget)="onMoveToTarget()" (onMoveAllToTarget)="onMoveAllToTarget()"
                        [responsive]="true" [dragdrop]="true" [showSourceControls]="false" [showTargetControls]="false">
                    <ng-template let-role pTemplate="item">
                    <div class="ui-helper-clearfix">
                        <div>{{role.label}}<i *ngIf="isRoleLocked(role)" class="pi pi-lock ml-2" title="Required role"></i></div>
                    </div>
                    </ng-template>
                </p-pickList>

                <div class="col-12">
                    <label>{{roleDescrHint}}</label>
                </div>

            </p-tabpanel>

            <p-tabpanel [value]="'brands'">

                <p-listbox [options]="brandCodes" [(ngModel)]="selectedBrandCodes" [checkbox]="true"  [filter]="true" 
                  [multiple]="true" optionLabel="name" [style]="{'width':'30rem'}" [listStyle]="{'max-height':'25rem'}">
                </p-listbox>

            </p-tabpanel>

            <p-tabpanel [value]="'passwordReset'">

                <form [formGroup]="passwordForm">

                  <div class="field grid">
                      <div class="col-1"></div>
                          <label for="newPassword" class="col-fixed label" style="width: 10em">New Password:</label>
                      <div class="col-6">
                          <input pPassword type="password" id="newPassword" formControlName="newPassword"/>
                          <!-- <div *ngIf="!passwordForm.controls['newPassword'].valid && passwordForm.controls['newPassword'].dirty" class="alert alert-danger">
                              Incorrect new password
                          </div>                                     -->
                          <div *ngIf="!passwordForm.get('newPassword')?.valid && passwordForm.get('newPassword')?.dirty" class="alert alert-danger">
                              Incorrect new password
                          </div>                                    
                      </div>
                  </div>
                  
                  <div class="field grid">
                      <div class="col-1"></div>
                          <label for="confirmPassword" class="col-fixed label" style="width: 10em">Confirm Password:</label>
                      <div class="col-6">
                          <input pPassword type="password" id="confirmPassword"  formControlName="confirmPassword"/>
                          <!-- <div *ngIf="!passwordForm.controls['confirmPassword'].valid && passwordForm.controls['confirmPassword'].dirty" class="alert alert-danger">
                              Incorrect confirm password
                          </div>                                     -->
                          <div *ngIf="!passwordForm.get('confirmPassword')?.valid && passwordForm.get('confirmPassword')?.dirty" class="alert alert-danger">
                              Incorrect confirm password
                          </div>                                    
                      </div>
                  </div>

                  <div class="field grid">
                    <p-button type="button" label="Submit" (click)="onSubmitPassswordReset()" [disabled]="!passwordForm.valid"
                      styleClass="p-button-success wal-success wal-success p-button-raised p-button-rounded margin-left">
                  </p-button>                                    
                  </div>

                </form>

            </p-tabpanel>

          </p-tabpanels>        

        </p-tabs>

    </div>

    <ng-template #footer>

      @if(!isSubmitHidden) {

      <div class="footer-actions">

        <p-button label="Unlock" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="unlock()" *ngIf="isUnlockVisible && isSubmitShown"></p-button>
        <p-button label="Delete" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="delete()" *ngIf="isSubmitShown"></p-button>
        <p-button label="Save" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSaveUserClick()" *ngIf="isSubmitShown"></p-button>
        <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="cancel()"></p-button>

      </div>
      }

    </ng-template>

    <!-- </p-footer> -->

</p-dialog>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="portal-user"></p-confirmDialog>

<!-- 
<p-tabs [(value)]="tabIndex">
  <p-tablist>
    <p-tab [value]="'properties'">
      <ng-template pTemplate="header">Properties</ng-template>
    </p-tab>
    <p-tab [value]="'roles'">
      <ng-template pTemplate="header">Roles</ng-template>
    </p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="'properties'">A</p-tabpanel>
    <p-tabpanel [value]="'roles'">B</p-tabpanel>
  </p-tabpanels>
</p-tabs> -->
